import React from "react";

import { SpacerBlock as Value } from "@reactivated";

import { concatClassNames, getStyleVariantClass } from "../../utils/styles";

interface ExtendableValue<Height extends string | null>
    extends Omit<Value, "height"> {
    height: Height;
}

type HeightClasses<Height extends string> = {
    [T in Height]: string;
};

interface Props<Height extends string | null = Value["height"]> {
    value: ExtendableValue<Height>;
    heightClasses: HeightClasses<Exclude<Height, null>>;
    className?: string;
}

export const AbstractSpacerBlock = (props: Props) => {
    const spacerStyle = getStyleVariantClass(
        props.heightClasses,
        props.value.height,
    );
    return props.value.anchor ? (
        <a
            id={props.value.anchor}
            className={concatClassNames([spacerStyle, props.className])}
        />
    ) : (
        <div
            aria-hidden="true"
            className={concatClassNames([spacerStyle, props.className])}
        />
    );
};
